import { IndicatorKeyEnum } from '../../../models/IndicatorKeyEnum';

export const getEmptyEsgBarchartIndicator = currentIndicator => ({
  ...currentIndicator,
  data:
    currentIndicator.indicatorKey === IndicatorKeyEnum.ESG_SAFEGUARD_PERFORMANCE_RATING
      ? {
          labels: ['', '', ''],
          datasets: [
            {
              data: [0, 0, 0],
              backgroundColor: ['#D0D5E0', '#D0D5E0', '#D0D5E0'],
              borderWidth: 0,
              barThickness: 25,
              label: 'firstStack',
            },
            {
              data: [0, 0],
              backgroundColor: ['#D0D5E0', '#D0D5E0'],
              borderWidth: 0,
              barThickness: 25,
              label: 'secondStack',
            },
          ],
          subLabels: [],
          cornerRadius: 3,
          gridLines: true,
          dataListTranslationLabels: [
            'satisfactory',
            'partially_satisfactory',
            'unsatisfactory',
            'partially_unsatisfactory',
            'not_assigned',
          ],
          dataQtyProjects: [0, 0, 0, 0, 0],
        }
      : {
          labels: ['', '', '', '', ''],
          datasets: [
            {
              data: [0, 0, 0, 0, 0],
              backgroundColor: ['#D0D5E0', '#D0D5E0', '#D0D5E0', '#D0D5E0', '#D0D5E0'],
              borderWidth: 0,
              barThickness: 25,
              label: 'firstStack',
            },
          ],
          subLabels: [],
          cornerRadius: 3,
          gridLines: true,
          dataListTranslationLabels: ['high', 'substantial', 'moderate', 'low', 'not_assigned'],
          dataQtyProjects: [0, 0, 0, 0, 0],
        },
});
